import { render, staticRenderFns } from "./InfoMessageEditDialog.vue?vue&type=template&id=ea68355a"
import script from "./InfoMessageEditDialog.vue?vue&type=script&lang=js"
export * from "./InfoMessageEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports